import React from "react";
import { AppProvider } from "./src/context";

import GTM from "@utils/GTM";
import { initCookieConsent } from "@utils/cookieConsent";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import "@styles/cookieconsent-overrides.css";

// Only the weights the site uses, Latin subset only. Every extra weight/subset
// gets inlined as base64 into each page's <style>
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
// Supports weights 100-900
import '@fontsource-variable/fraunces';
// Supports weights 400-700
import '@fontsource-variable/lora';

import "@styles/fonts.css";
import "@styles/global.css";
import "@styles/zoom.css";
import "@styles/screenshots.css";

export const onInitialClientRender = () => {
  GTM.loadScript();
  initCookieConsent();
};

export const onRouteUpdate = () => {
  GTM.reset();
};

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
